import baseURL from "../common/axios";
class TeleCallService {
  //To Insert TeleCall-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("TeleCall/Create", dataModel);
  }
  //To Update TeleCall-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("TeleCall/Update", dataModel);
  }
  //To Insert TeleCall-->MOPCRM API
  clicktocall(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("TeleCall/ClickToCall", dataModel);
  }
  //To Insert TeleCall-->MOPCRM API
  clicktoCallOptions(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("TeleCall/CallOptions", dataModel);
  }
  //To Delete TeleCall-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("TeleCall/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "TeleCall/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get TeleCall List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("TeleCall/List");
  }
  //To Get TeleCall List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("TeleCall/Get?id=" + Id + "");
  }

  AgentBlockAndUnblock(ObjValue) {
    return baseURL.httpMSMOPCRMUrl.post(
      "TeleCall/AgentBlockAndUnblock",
      ObjValue
    );
  }
}
export default new TeleCallService();
